import React from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';

const Schedule = () => {
  return (
    <section id="schedule" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-5 pointer-events-none">
        <img
          src="https://public.youware.com/users-website-assets/prod/42806107-9efa-4743-9602-d260f74d9046/2e391a9608df451c8a7113e8a31222f0.jpg"
          alt="Piano Keys"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">開催概要</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-100">
            <div className="p-8 text-center hover:bg-gray-50 transition-colors">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 text-blue-900 rounded-full mb-6">
                <Calendar size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">開催日</h3>
              <p className="text-2xl font-bold text-blue-900">2026.8.29</p>
              <p className="text-gray-500 mt-1">土曜日</p>
            </div>

            <div className="p-8 text-center hover:bg-gray-50 transition-colors">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 text-blue-900 rounded-full mb-6">
                <Clock size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">時間</h3>
              <p className="text-2xl font-bold text-blue-900">10:00 - 19:00</p>
              <p className="text-gray-500 mt-1">開場 9:30（予定）</p>
            </div>

            <div className="p-8 text-center hover:bg-gray-50 transition-colors">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 text-blue-900 rounded-full mb-6">
                <MapPin size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">会場</h3>
              <p className="text-lg font-bold text-blue-900">東京芸術センター21階</p>
              <p className="text-gray-500 mt-1">天空劇場</p>
            </div>
          </div>
          
          <div className="bg-blue-900 text-white p-6 text-center">
            <p className="text-sm md:text-base tracking-wider">
              ※ スケジュールは進行状況により変更となる場合がございます。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;
